<div *ngIf="teachersTabs.length" class="filter-block">
  <on-ui-tabs [tabs]="tabs" displayMode="delimiter"></on-ui-tabs>
</div>

<app-school-calendar *ngIf="!!school && !selectedTeacher" [school]="school" [teachers]="schoolTeachers"></app-school-calendar>

<app-school-teacher-calendar *ngIf="!!school && !!selectedTeacher" [school]="school" [teacher]="selectedTeacher"></app-school-teacher-calendar>
